import mime from "mime";

export const getChatAttachmentName = (
	name: string | null | undefined,
	mimeType: string,
	id: number,
): string => {
	const given = name?.trim();
	if (given) return given;

	const extension = mime.getExtension(mimeType);

	return extension ? `attachment-${id}.${extension}` : `attachment-${id}`;
};
